import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

export const ALERTS_QUERY_KEY = ["alerts"] as const;

type AlertSortKey = components["schemas"]["AlertSortKey"];
type SortOrder = components["schemas"]["SortOrder"];

export type ListAlertsQuery = {
  include_acknowledged?: boolean;
  sort_key?: AlertSortKey;
  sort_order?: SortOrder;
  limit?: number;
  offset?: number;
};

export function useAlerts(params: ListAlertsQuery = {}) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...ALERTS_QUERY_KEY, params],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/alerts", {
        params: { query: params },
      });
      if (error !== undefined) {
        throw new Error("Failed to list alerts");
      }
      return data;
    },
  });
}
